<template>
  <v-dialog
    v-model="dialog"
    max-width="1024"
    persistent
  >
    <v-card>
      <v-card-title
        primary-title
        class="text-uppercase deep-orange darken-1 white--text"
      >
        <v-icon
          color="white"
          class="mr-2"
        >
          notification_important
        </v-icon>
        Potential Adversities Detected
      </v-card-title>

      <v-container>
        <Adversities
          :adversities="adversities"
          :update="updateResolutionStatus"
        />
      </v-container>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="green darken-1"
          text
          @click="dialog = false"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary darken-1"
          text
          :disabled="canNotGoNext"
          @click="_ => onProceed(forceCreationComment)"
        >
          Proceed
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { isEmpty } from 'lodash'

import Adversities from '@/components/Party/Adversities.vue'

export default {
  name: 'PEPartyAdversitiesDialog',

  components: {
    Adversities,
  },

  props: {
    adversities: {
      type: Array,
      required: true,
    },

    onProceed: {
      type: Function,
      required: true,
    },

    value: {
      type: Boolean,
      required: true,
    },

  },

  data () {
    return {
      adversityRecognized: null,
      adversityResolved: false,
      forceCreationComment: null,
      forcePartyCreation: null,
    }
  },

  computed: {
    canNotGoNext () {
      return this.adversityResolved === false
    },

    dialog: {
      get () { return this.value },

      set (val) {
        this.$emit('input', val)
      },
    },

  },

  methods: {
    updateResolutionStatus (data) {
      this.adversityResolved = (
        data.adversityRecognized === false ||
        data.forcePartyCreation === false ||
        !isEmpty(data.forceCreationComment)
      )

      this.forceCreationComment = data.forceCreationComment
    },
  },

}
</script>
